<div class="p-6 space-y-6">

  <!-- Card: Filtros -->
  <div class="bg-white rounded-xl shadow-sm p-6">
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-bold text-gray-800">Gestion masiva</h2>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- Profesor -->
      <app-custom-dropdown
        label="Profesor"
        [(ngModel)]="selectedTeacherId"
        [options]="teachers"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccionar profesor">
      </app-custom-dropdown>

      <!-- Rango de fechas -->
      <div class="gestion-calendar-wrapper">
        <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Rango de fechas <span class="text-red-500">*</span>
        </label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          [showIcon]="true"
          [showOnFocus]="true"
          [readonlyInput]="true"
          dateFormat="dd/mm/yy"
          placeholder="Selecciona un rango de fechas"
          inputId="dateRangeGestion">
        </p-calendar>
      </div>

      <!-- Estado -->
      <app-custom-dropdown
        label="Estado"
        [(ngModel)]="filterStatus"
        [options]="statuses"
        optionLabel="label"
        optionValue="value"
        placeholder="Todos">
      </app-custom-dropdown>
    </div>

    <!-- Boton buscar -->
    <div class="flex justify-end mt-6">
      <button (click)="search()"
        [disabled]="loading || !selectedTeacherId || !dateRange || dateRange.length < 2 || !dateRange[0] || !dateRange[1]"
        class="px-6 py-3 bg-red-600 text-white text-sm font-semibold rounded-xl hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm hover:shadow-md flex items-center gap-2">
        <svg *ngIf="loading" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        <svg *ngIf="!loading" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        {{ loading ? 'Buscando...' : 'Buscar' }}
      </button>
    </div>
  </div>

  <!-- Barra de acciones masivas -->
  <div *ngIf="selectedCount > 0" class="sticky top-4 z-10 bg-white border border-gray-200 rounded-xl shadow-sm p-4">

    <!-- Fila superior: seleccion e info -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-3">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="checkbox"
            [checked]="allSelected"
            (change)="toggleSelectAll()"
            class="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500">
          <span class="text-sm font-medium text-gray-700">Seleccionar todo</span>
        </label>
        <span class="text-sm text-gray-500">
          <span class="font-semibold text-red-600">{{ selectedCount }}</span> clases seleccionadas
        </span>
      </div>

      <!-- Boton eliminar -->
      <button (click)="showDeleteConfirm = true"
        [disabled]="loadingAction"
        class="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
        </svg>
        Eliminar
      </button>
    </div>

    <!-- Fila inferior: acciones -->
    <div class="flex flex-wrap items-end gap-4 pt-4 border-t border-gray-100">

      <!-- Cambiar estado -->
      <div class="flex items-end gap-2">
        <div class="w-44">
          <app-custom-dropdown
            label="Cambiar estado"
            [(ngModel)]="bulkStatus"
            [options]="statuses"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccionar"
            [showClear]="false">
          </app-custom-dropdown>
        </div>
        <button (click)="bulkChangeStatus()"
          [disabled]="loadingAction || !bulkStatus"
          class="px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          Aplicar
        </button>
      </div>

      <!-- Separador -->
      <div class="hidden lg:block w-px h-10 bg-gray-200"></div>

      <!-- Cambiar vehiculo -->
      <div class="flex items-end gap-2">
        <div class="w-52">
          <app-custom-dropdown
            label="Cambiar vehiculo"
            [(ngModel)]="bulkVehicleId"
            [options]="vehicles"
            optionLabel="model"
            optionValue="id"
            placeholder="Seleccionar"
            [filterFields]="['model', 'license_plate']"
            [showClear]="false">
            <ng-template #itemTemplate let-vehicle>
              <div>{{ vehicle.model }} - {{ vehicle.license_plate }}</div>
            </ng-template>
            <ng-template #selectedItemTemplate let-vehicle>
              <div *ngIf="vehicle">{{ vehicle.model }} - {{ vehicle.license_plate }}</div>
            </ng-template>
          </app-custom-dropdown>
        </div>
        <button (click)="bulkChangeVehicle()"
          [disabled]="loadingAction || !bulkVehicleId"
          class="px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          Aplicar
        </button>
      </div>

      <!-- Separador -->
      <div class="hidden lg:block w-px h-10 bg-gray-200"></div>

      <!-- Cambiar horario -->
      <div class="flex items-end gap-2">
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Hora inicio</label>
          <input type="time" [(ngModel)]="bulkStartTime"
            class="w-32 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Hora fin</label>
          <input type="time" [(ngModel)]="bulkEndTime"
            class="w-32 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>
        <button (click)="bulkChangeTime()"
          [disabled]="loadingAction || !bulkStartTime || !bulkEndTime"
          class="px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          Aplicar
        </button>
      </div>

      <!-- Separador -->
      <div class="hidden lg:block w-px h-10 bg-gray-200"></div>

      <!-- Cambiar capacidad -->
      <div class="flex items-end gap-2">
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Máx. alumnos</label>
          <input type="number" [(ngModel)]="bulkMaxStudents" min="1" max="10"
            class="w-24 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 text-center focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all">
        </div>
        <button (click)="bulkChangeCapacity()"
          [disabled]="loadingAction || !bulkMaxStudents || bulkMaxStudents < 1"
          class="px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          Aplicar
        </button>
      </div>
    </div>

    <!-- Loading overlay para acciones -->
    <div *ngIf="loadingAction" class="absolute inset-0 bg-white/60 rounded-xl flex items-center justify-center">
      <svg class="animate-spin h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
    </div>
  </div>

  <!-- Modal de confirmacion de eliminacion -->
  <div *ngIf="showDeleteConfirm" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div class="bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900">Confirmar eliminacion</h3>
      </div>
      <p class="text-sm text-gray-600 mb-6">
        ¿Estas seguro de que quieres eliminar <span class="font-semibold text-red-600">{{ selectedCount }}</span> clases seleccionadas? Esta accion no se puede deshacer.
      </p>
      <div class="flex items-center justify-end gap-3">
        <button (click)="showDeleteConfirm = false"
          class="px-4 py-2.5 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors">
          Cancelar
        </button>
        <button (click)="bulkDelete()"
          [disabled]="loadingAction"
          class="px-4 py-2.5 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-2">
          <svg *ngIf="loadingAction" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          Eliminar
        </button>
      </div>
    </div>
  </div>

  <!-- Tabla de resultados -->
  <div *ngIf="schedules.length > 0" class="bg-white rounded-xl shadow-sm p-6">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-bold text-gray-800">Resultados</h2>
      <span class="text-sm text-gray-500">{{ schedules.length }} clases encontradas</span>
    </div>

    <!-- Seleccion por dia -->
    <div class="flex items-center gap-2 mb-4 flex-wrap">
      <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide mr-1">Seleccionar por dia:</span>
      <button *ngFor="let day of dayFilterButtons"
        type="button"
        (click)="toggleDayFilter(day)"
        class="px-3 py-1.5 rounded-full text-xs font-medium transition-all border"
        [ngClass]="{
          'bg-red-600 text-white border-red-600': day.active,
          'bg-white text-gray-600 border-gray-200 hover:border-gray-400': !day.active
        }">
        {{ day.shortLabel }}
      </button>
      <button *ngIf="hasActiveDayFilters"
        type="button"
        (click)="clearDayFilters(); clearSelection()"
        class="px-3 py-1.5 text-xs text-gray-500 hover:text-gray-700 underline">
        Limpiar
      </button>
    </div>

    <div class="overflow-x-auto rounded-xl border border-gray-200">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-left">
            <th class="px-4 py-3 w-12">
              <input type="checkbox"
                [checked]="allSelected"
                (change)="toggleSelectAll()"
                class="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500">
            </th>
            <th class="px-4 py-3 font-semibold text-gray-600">Fecha</th>
            <th class="px-4 py-3 font-semibold text-gray-600">Dia</th>
            <th class="px-4 py-3 font-semibold text-gray-600">Hora</th>
            <th class="px-4 py-3 font-semibold text-gray-600">Tipo</th>
            <th class="px-4 py-3 font-semibold text-gray-600">Estado</th>
            <th class="px-4 py-3 font-semibold text-gray-600">Vehiculo</th>
            <th class="px-4 py-3 font-semibold text-gray-600 text-center">Máx. alumnos</th>
            <th class="px-4 py-3 font-semibold text-gray-600 text-center">Reservas</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          <tr *ngFor="let schedule of schedules"
            class="hover:bg-gray-50 transition-colors"
            [ngClass]="{ 'bg-red-50/50': isSelected(schedule.id) }">
            <td class="px-4 py-2.5">
              <input type="checkbox"
                [checked]="isSelected(schedule.id)"
                (change)="toggleSelect(schedule.id)"
                class="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500">
            </td>
            <td class="px-4 py-2.5 text-gray-800 font-medium">{{ formatDisplayDate(schedule.date) }}</td>
            <td class="px-4 py-2.5 text-gray-600">{{ getDayName(schedule.date) }}</td>
            <td class="px-4 py-2.5 text-gray-700">
              {{ schedule.start_time?.substring(0, 5) }} - {{ schedule.end_time?.substring(0, 5) }}
            </td>
            <td class="px-4 py-2.5">
              <span class="inline-block px-2.5 py-1 rounded-full text-xs font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-700': schedule.practice_type === 'Abierto',
                  'bg-orange-100 text-orange-700': schedule.practice_type === 'Maniobras'
                }">
                {{ schedule.practice_type }}
              </span>
            </td>
            <td class="px-4 py-2.5">
              <span class="inline-block px-2.5 py-1 rounded-full text-xs font-medium"
                [ngClass]="getStatusClass(schedule.status)">
                {{ schedule.status }}
              </span>
            </td>
            <td class="px-4 py-2.5 text-gray-600">
              <span *ngIf="schedule.vehicle">{{ schedule.vehicle.model }} - {{ schedule.vehicle.license_plate }}</span>
              <span *ngIf="!schedule.vehicle" class="text-gray-400">Sin asignar</span>
            </td>
            <td class="px-4 py-2.5 text-center text-gray-700 font-medium">
              {{ schedule.max_students }}
            </td>
            <td class="px-4 py-2.5 text-center">
              <span class="inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold"
                [ngClass]="{
                  'bg-gray-100 text-gray-500': !schedule.bookings_count || schedule.bookings_count === 0,
                  'bg-yellow-100 text-yellow-700': schedule.bookings_count > 0 && schedule.bookings_count < schedule.max_students,
                  'bg-green-100 text-green-700': schedule.bookings_count >= schedule.max_students
                }">
                {{ schedule.bookings_count || 0 }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Estado vacio: sin busqueda -->
  <div *ngIf="schedules.length === 0 && !loading" class="bg-white rounded-xl shadow-sm p-12">
    <div class="text-center">
      <svg class="mx-auto h-12 w-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
      </svg>
      <p class="text-sm text-gray-400">
        Selecciona un profesor y rango de fechas para buscar
      </p>
    </div>
  </div>

  <!-- Loading state para busqueda -->
  <div *ngIf="loading" class="bg-white rounded-xl shadow-sm p-12">
    <div class="flex flex-col items-center justify-center">
      <svg class="animate-spin h-8 w-8 text-red-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      <p class="text-sm text-gray-500">Buscando clases...</p>
    </div>
  </div>

</div>
